import React from 'react';
import glamorous from 'glamorous';

import GettingAccessToApiKey from './getting-access-to-api-key';
import { MENU_ENTRIES } from '../constants';

const ApiKey = () => {
  return (
    <div data-subsection={MENU_ENTRIES.apiKey}>
      <h3>
        API KEY
      </h3>
      <p>
        The API key is a mechanism which ensures that the user/server attempting to load recalls is effectively granted
        permission to complete the task of importing a recall (update, insert or delete modes) for a specified
        jurisdiction.
      </p>
      <p>
        Each agency contributing to the OECD <i>GlobalRecalls</i> portal needs access to at least one API key. For
        manual
        uploads, one API key can be allocated per staff member designated to contributing to the
        OECD <i>GlobalRecalls</i> portal. It is up to each agency to decide the number of staff members that should have
        access to an API key. For
        automated uploads <i>via</i> a server, the agency will need access to at least two API keys (one for the server
        and one
        that can be used for manual uploads by a user if any issues arise).
      </p>
      <p>
        Any attempt to load recalls (manually or automatically) without any API key or with an API key NOT corresponding
        to the granted mode(s) of import and the granted jurisdiction codes will be systematically rejected.
      </p>
      <p>
        The API key is a strong authentication tool that provides a unique identifier for importing recalls, while
        still being simple to use.
      </p>
      <br/>
      <div data-subsection={MENU_ENTRIES.apiKeyGettingAccess}>
        <GettingAccessToApiKey/>
      </div>
    </div>
  );
};

export default ApiKey;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/api-key/index.js